import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Circle from '@/components/UI/svg/SaveElectric/Circle';
import LinkIcon from '@/components/UI/svg/SaveElectric/Link';

export default function E() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('save_electric');
    const [active, setActive] = useState(0);
    const innerLine: any = {
        0: {
            width: 432,
            left: 0,
        },
        1: {
            width: 336,
            right: 0,
        },
    };

    return (
        <div className={`save-electric-e ${css.SaveElectricE}`}>
            <section className="section-a">
                <div className="text-wrapper">
                    <h2 className="title">{t('sec_6_title')}</h2>
                    <div className="tab">
                        <div className="line">
                            <div className="inner-line" style={innerLine[active]}></div>
                        </div>
                        <div className="text">
                            <p className={active === 0 ? 'active' : ''} onClick={() => setActive(0)}>
                                {t('sec_6_tab1')}
                            </p>
                            <p className={active === 1 ? 'active' : ''} onClick={() => setActive(1)}>
                                {t('sec_6_tab2')}
                            </p>
                        </div>
                    </div>
                    <div className={`tab-content ${active === 0 ? 'show' : ''}`}>
                        <div className="solution content-1">
                            <div className="icon">
                                <Circle num={1} />
                            </div>
                            <div className="right">
                                <p className="text-white">{t('sec_6_tab1_text1')}</p>
                            </div>
                        </div>
                        <div className="solution">
                            <div className="icon">
                                <Circle num={2} />
                            </div>
                            <div className="right">
                                <p className="text-white">{t('sec_6_tab1_text2')}</p>
                            </div>
                        </div>
                        <div className="solution">
                            <div className="icon">
                                <Circle num={3} />
                            </div>
                            <div className="right">
                                <p className="text-white">{t('sec_6_tab1_text3')}</p>
                            </div>
                        </div>
                        <Link
                            className="link_btn"
                            href="https://blog.ecoflow.com/jp/be-patient/"
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'select_news',
                                title_name: t('sec_6_title'),
                                button_name: t('sec_6_btn'),
                            }}
                        >
                            {t('sec_6_btn')}
                            <span className="icon icon-white">
                                <LinkIcon />
                            </span>
                            <span className="icon icon-blue">
                                <LinkIcon stroke="#3f68e0" />
                            </span>
                        </Link>
                    </div>
                    <div className={`tab-content ${active === 1 ? 'show' : ''}`}>
                        <p className="text-white content-2">{t('sec_6_tab2_desc')}</p>
                        <div className="solution content-2">
                            <div className="icon">
                                <Circle num={1} />
                            </div>
                            <div className="right text">
                                {t.rich('sec_6_tab2_text1', {
                                    title: (text: string) => <p className="text-white">{text}</p>,
                                })}
                            </div>
                        </div>
                        <div className="solution content-2">
                            <div className="icon">
                                <Circle num={2} />
                            </div>
                            <div className="right text">
                                {t.rich('sec_6_tab2_text2', {
                                    title: (text: string) => <p className="text-white">{text}</p>,
                                })}
                            </div>
                        </div>
                        <div className="solution content-2">
                            <div className="icon">
                                <Circle num={3} />
                            </div>
                            <div className="right text">
                                {t.rich('sec_6_tab2_text3', {
                                    title: (text: string) => <p className="text-white">{text}</p>,
                                })}
                            </div>
                        </div>
                        <div className="solution content-2">
                            <div className="icon">
                                <Circle num={4} />
                            </div>
                            <div className="right text">
                                {t.rich('sec_6_tab2_text4', {
                                    title: (text: string) => <p className="text-white">{text}</p>,
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-b">
                <h2 className="title">{t('sec_7_title')}</h2>
                <div className="desc">
                    {t.rich('sec_7_desc', {
                        p: (text: string) => <p className="p">{text}</p>,
                        bold: (text: string) => <p className="bold">{text}</p>,
                    })}
                </div>
            </section>
        </div>
    );
}
